import { createAsyncThunk } from '@reduxjs/toolkit';

import { FETCH_PAGINATED_CUSTOMERS } from '~/actions/names';

import {
  deleteCustomer as deleteCustomerRequest,
  getCustomers,
  createCustomer as createCustomerRequest,
  editCustomer as editCustomerRequest,
} from '../api/customers';

export const fetchPaginatedCustomers = createAsyncThunk(
  FETCH_PAGINATED_CUSTOMERS,
  async (
    {
      limit: requestLimit = 10,
      offset: requestOffset = 0,
      sort = 'name',
      order = 'asc',
      filters: requestFilters,
      force = false,
    },
    { getState }
  ) => {
    let limit;
    let offset;
    let filters;

    if (force) {
      const { paginated_customers } = getState();

      limit = paginated_customers.limit;
      offset = paginated_customers.offset;
      filters = paginated_customers.filters;
    }

    limit = limit ?? requestLimit;
    offset = offset ?? requestOffset;
    filters = filters ?? requestFilters;

    const { customers, total } = await getCustomers({
      limit,
      offset,
      sort,
      order,
      filters,
    });

    return { customers, total, offset, limit, filters };
  }
);

export const deleteCustomer = (customerID) => async (dispatch) => {
  await deleteCustomerRequest(customerID);

  dispatch(fetchPaginatedCustomers({ force: true }));
};

export const createCustomer = (payload) => async (dispatch) => {
  await createCustomerRequest(payload);

  dispatch(fetchPaginatedCustomers({ force: true }));
};

export const editPaginatedCustomer = (payload) => async (dispatch) => {
  const customerID = payload._id || payload.id;

  await editCustomerRequest(customerID, payload);

  dispatch(fetchPaginatedCustomers({ force: true }));
};
